import React from 'react'

function RealEstate() {
  return (
    <div>RealEstate</div>
  )
}

export default RealEstate